import React from 'react';

import { selectUserData } from 'redux/editProfile/userProfile.slices';
import { useAppSelector } from 'redux/hooks';

type Props = {
  permissionRequired: string;
  children?: React.ReactNode;
  hasPermission?: boolean;
};

const WithPermission = (props: Props) => {
  const { permissionRequired, children } = props;
  const user = useAppSelector(selectUserData);

  if (!user) {
    return <></>;
  }

  return <>{user[permissionRequired] && children}</>;
};

export default WithPermission;
